/**
 * Dineo Design System - Breakpoints
 *
 * Standard MUI breakpoints plus a custom `kds` breakpoint
 * for Kitchen Display System screens (typically large wall-mounted monitors).
 */

export const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 900,
    lg: 1200,
    xl: 1536,
    kds: 1920,
  },
};
